import templateUrl from 'emun.salesrep/new-customer-vendor-count.htm';
import AutoQuery from 'servicestack/auto-query/auto-query';
import basicController from 'servicestack/basic.controller.properties';
import resolve from 'ioc/resolve';

class NewCustomerVendorCountController {
  constructor($rootScope) {
    const $ctrl = this;
    basicController($ctrl);

    var newCustomerUrl = 'QueryNewCustomerVendorCounts.json?GroupBy=VendorName&Sum=YTDCount,QuarterCount,MTDCount';
    var context = $ctrl.context || 'rep';
    var repFilter = "";
    if (context !== 'writingRep') {
      if (context !== 'executive') {
        var filterType = "SalesRepID";
        if (context === 'manager') {
          filterType = 'ManagerId';
        }
        repFilter = "&" + filterType + "=" + $ctrl.rep.id;
      }
    }
    if ($ctrl.repGroup) {
      if ($ctrl.repGroup !== 'ALL') {
        newCustomerUrl = newCustomerUrl + '&RepGroupName=' + $ctrl.repGroup;
      }
    }
    if ($ctrl.insideSales) {
      if ($ctrl.insideSales === 'true') {
        newCustomerUrl = newCustomerUrl + '&IsInsideSales=true';
      }
    }
    
    if (($ctrl.salesRepId) && (context === 'writingRep')) {
      repFilter = "&SalesRepID=" + $ctrl.salesRepId;
    }else if (context === "writingRep") {
      repFilter = "&WritingRep=" + $ctrl.writingRepId;
    }
    if (repFilter !== '') {
      newCustomerUrl = newCustomerUrl + repFilter;
    }

    $ctrl.NewCustomerVendorCount = new AutoQuery({
      //url: 'QueryNewCustomerVendorCounts.json?GroupBy=VendorName&CountDistinct=CustomerID' + repFilter,
      url: newCustomerUrl,
      orderBy: 'VendorName',
      autoLoad: true,
      pageSize: 100,
      scrollTop: false
    })
  }
}

let NewCustomerVendorCount = {
  bindings: {
    repId: '@',
    repGroup: '@',
    context: '@',
    rep: '<',
    insideSales: '@',
    writingRepId: '@',
    salesRepId: '@'
  },
  controller: NewCustomerVendorCountController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default NewCustomerVendorCount